module.exports = __webpack_public_path__ + "static/media/CFDI.08b33430.png";